export const INIT_CLIENT_REDUCER = 'INIT_CLIENT_REDUCER';
export const SELECT_PROCESS_CLIENT_REDUCER = 'SELECT_PROCESS_CLIENT_REDUCER';
